import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M2.4 3.6h19.2V12h1.2V2.4H1.2v20.4H12v-1.2H2.4v-18z" fill="#000" /><path fillRule="evenodd" clipRule="evenodd" d="M6.6 6V0h1.2v6H6.6zm10.8-6v6h-1.2V0h1.2zM1.8 7.8h20.4V9H1.8V7.8zM18.6 18.6v-4.2h1.2v4.2H24v1.2h-4.2V24h-1.2v-4.2h-4.2v-1.2h4.2z" fill="#000" /></svg>;